import React from 'react'

import { get } from '@js/common/api'
import { UA } from '@js/common/UA'

import Modal from '@f/components/Modal'

import RequestWizard from '@f-fertighaus/applications/RequestWizard'

const flowType = type => {
  return type && type.house
}

const requestPageType = 'house-detail-form'
const { delivery_region, country, postal_code } = UA.getLS()

export const modalState = async event => {
  const vendorNid =
    event.target.closest('.js-house-detail-page')?.dataset?.vendorNid ||
    event.target.dataset?.vendorNid

  const params = {
    nid: vendorNid,
    delivery_region: delivery_region,
    postal_code: `${country}-${postal_code}`
  }

  switch (UA.getCurrentUserState()) {
    case 'handover':
      try {
        const vendors = await get('users/current/leads/')
        if (vendors.find(vendor => vendor.vendor_nid === vendorNid)) {
          return {
            label: 'Vendor Already in Recommendation',
            name: 'pcr-ho-lead-exists',
            vendorNid
          }
        }
        const { match } = (await get('vendor-match/', params)) || {}
        return match
          ? {
              label: 'Add Vendor to Recommendation - handed_over',
              name: 'pcr-ho-add-vendor',
              vendorNid
            }
          : {
              label: 'Vendor no-match - handed_over',
              name: 'pcr-ho-no-match',
              vendorNid
            }
      } catch (error) {
        console.log(error)
      }

    case 'conversion_prequal':
      try {
        const { match } = (await get('vendor-match/', params)) || {}
        return match
          ? {
              label: 'Prequal Required - Match',
              name: 'pcr-conv-pq-reminder',
              vendorNid
            }
          : {
              label: 'Prequal Required - No-Match',
              name: 'pcr-conv-pq-no-match',
              vendorNid
            }
      } catch (error) {
        console.log(error)
      }

    case 'conversion_non_prequal':
      try {
        const { match } = (await get('vendor-match/', params)) || {}
        return match
          ? {
              label: 'No-Prequal Vendor Match',
              name: 'pcr-conv-no-pq-match',
              vendorNid
            }
          : {
              label: 'No-Prequal Vendor No-Match',
              name: 'pcr-conv-no-pq-no-match',
              vendorNid
            }
      } catch (error) {
        console.log(error)
      }
  }
}

const conversionFunnelVariants = [
  'house-wizard-item-priceinfo',
  'house-wizard-item-infomaterial',
  'house-wizard-item-configuration',
  'house-wizard-item-offer',
  'house-wizard-item-comparison',
  'house-wizard-item-catalog',
  'house-wizard-item-appointment',
  'house-wizard-item-favourite',
  'house-wizard-item-expose'
]

async function openRequestOverlay(event) {
  const props = {
    requestType: 'house-detail-form',
    funnelVariant: event.target.dataset.funnelVariant
  }

  if (
    event &&
    event.target.className.toString().indexOf('js-request-button') < 0
  ) {
    return
  }

  if (!conversionFunnelVariants.includes(props.funnelVariant)) {
    console.error('Unknown funnel variant - ', props.funnelVariant)
  }

  if (event) {
    event.preventDefault()
    event.stopPropagation()

    props.requestType = event.target.dataset.requestType
    if (event.target.dataset.introType) {
      props.introType = event.target.dataset.introType
    }
  }

  props.houses = [
    document.body.dataset.nid,
    event.target.dataset.houseNid
  ].filter(Boolean)
  props.requestFunnel = 'house-detail'

  const modal = new Modal()

  if (UA.isLoggedIn()) {
    UA.getUserData()
  }

  if (
    UA.isLoggedIn() &&
    [delivery_region, country, postal_code].every(param => !!param)
  ) {
    modalState(event).then(async ({ name, vendorNid } = {}) => {
      if (name === 'pcr-ho-lead-exists') {
        UA.getUserLeads().then(async leads => {
          const { UAContactVendorModal } = await import(
            '@f-fertighaus/applications/UserAccount/modals/UAContactVendorModal'
          )

          const accountLead =
            leads.find(lead => lead.vendor.nid === vendorNid) || {}

          let contactData = {}

          if (accountLead.assigned_sales_agent) {
            // Weird construction but allows not to display folks with empty names
            contactData = {
              data: {
                name: `${
                  accountLead.assigned_sales_agent.first_name
                    ? accountLead.assigned_sales_agent.first_name + ' '
                    : ''
                }${
                  accountLead.assigned_sales_agent.last_name
                    ? accountLead.assigned_sales_agent.last_name
                    : ''
                }`,
                img: accountLead.assigned_sales_agent.avatar,
                img_fallback: 'author-64px-fill',
                email: accountLead.assigned_sales_agent.email,
                phone_formatted: accountLead.assigned_sales_agent.phone
              },
              type: 'assigned_sales_agent',
              salesEntityText: 'Ihr Bauberater',
              contactEntityText: 'Berater kontaktieren'
            }
          } else if (accountLead.assigned_sales_office) {
            contactData = {
              data: {
                name: accountLead.assigned_sales_office.office_name,
                img: accountLead.assigned_sales_office.office_profile_picture,
                img_fallback: 'author-64px-fill',
                email: accountLead.assigned_sales_office.office_qualified_email,
                phone_formatted: accountLead.assigned_sales_office.office_phone
              },
              type: 'assigned_sales_office',
              salesEntityText: 'Ihr lokales Büro',
              contactEntityText: 'Büro kontaktieren'
            }
          } else if (accountLead.vendor) {
            contactData = {
              data: {
                name: accountLead.vendor.display_name,
                img: '',
                img_fallback: 'zentrale-64px',
                email: accountLead.vendor.contact_email,
                phone_formatted: accountLead.vendor.contact_phone
              },
              type: 'vendor',
              salesEntityText: 'Ihre Zentrale',
              contactEntityText: 'Zentrale kontaktieren'
            }
          }

          modal.openModal({
            component: (
              <UAContactVendorModal
                modalId={name}
                contactData={contactData.data}
                title='Dieser Anbieter ist bereits in Ihrer Empfehlung enthalten'
                closeModalTop
              />
            ),
            options: {
              wrapperClassName: 'UA-modal-wrap',
              className: 'UA-modal'
            }
          })
        })
      } else if (name === 'pcr-ho-add-vendor') {
        const { HOAddVendorToRecommendationModal } = await import(
          '@f-fertighaus/applications/UserAccount/modals/HOAddVendorToRecommendationModal'
        )
        get('vendors', {
          nid: vendorNid
        }).then(data =>
          modal.openModal({
            component: (
              <HOAddVendorToRecommendationModal
                houseNid={document.body.dataset.nid}
                modalId={name}
                vendorName={data.results[0]?.display_name}
                closeModalTop
                flowType={flowType({
                  house: 'house-wizard-item'
                })}
                funnel={props.requestFunnel}
                requestPageType={requestPageType}
              />
            ),
            options: {
              wrapperClassName: 'UA-modal-wrap',
              className: 'UA-modal'
            }
          })
        )
      } else if (
        name === 'pcr-ho-no-match' ||
        name === 'pcr-conv-no-pq-no-match'
      ) {
        const { VendorNoMatchModal } = await import(
          '@f-fertighaus/applications/UserAccount/modals/VendorNoMatchModal'
        )
        get('vendors', {
          nid: vendorNid
        }).then(data =>
          modal.openModal({
            component: (
              <VendorNoMatchModal
                modalId={name}
                vendorName={data.results[0]?.display_name}
                closeModalTop
              />
            ),
            options: {
              wrapperClassName: 'UA-modal-wrap',
              className: 'UA-modal'
            }
          })
        )
      } else if (name === 'pcr-conv-pq-reminder') {
        const { PQRequiredMatchModal } = await import(
          '@f-fertighaus/applications/UserAccount/modals/PQRequiredMatchModal'
        )
        get('vendors', {
          nid: vendorNid
        }).then(data =>
          modal.openModal({
            component: (
              <PQRequiredMatchModal
                modalId={name}
                vendorName={data.results[0]?.display_name}
                houseNid={document.body.dataset.nid}
                closeModalTop
                flowType={flowType({
                  house: 'house-wizard-item'
                })}
                funnel={props.requestFunnel}
                requestPageType={requestPageType}
              />
            ),
            options: {
              wrapperClassName: 'UA-modal-wrap',
              className: 'UA-modal'
            }
          })
        )
      } else if (name === 'pcr-conv-pq-no-match') {
        const { PQRequiredNoMatchModal } = await import(
          '@f-fertighaus/applications/UserAccount/modals/PQRequiredNoMatchModal'
        )
        get('vendors', {
          nid: vendorNid
        }).then(data =>
          modal.openModal({
            component: (
              <PQRequiredNoMatchModal
                modalId={name}
                vendorName={data.results[0]?.display_name}
                houseNid={document.body.dataset.nid}
                flowType={flowType({
                  house: 'house-wizard-item'
                })}
                funnel={props.requestFunnel}
                requestPageType={requestPageType}
                closeModalTop
              />
            ),
            options: {
              wrapperClassName: 'UA-modal-wrap',
              className: 'UA-modal'
            }
          })
        )
      } else if (name === 'pcr-conv-no-pq-match') {
        const { NoPQRequiredMatchModal } = await import(
          '@f-fertighaus/applications/UserAccount/modals/NoPQRequiredMatchModal'
        )
        get('vendors', {
          nid: vendorNid
        }).then(data =>
          modal.openModal({
            component: (
              <NoPQRequiredMatchModal
                modalId={name}
                vendorName={data.results[0]?.display_name}
                houseId={document.body.dataset.nid}
                closeModalTop
                flowType={flowType({
                  house: 'house-wizard-item'
                })}
                funnel={props.requestFunnel}
                requestPageType={requestPageType}
              />
            ),
            options: {
              wrapperClassName: 'UA-modal-wrap',
              className: 'UA-modal'
            }
          })
        )
      }
    })
  } else {
    modal.openModal({
      component: <RequestWizard {...props} />,
      options: {
        className: 'RequestWizard-content-wrapper--HDP_conversion-funnel'
      }
    })
  }
}

document.addEventListener('click', openRequestOverlay)

export { openRequestOverlay }
